import "../scss/faq.scss";
import { categoryAccordion } from '../components/faq';
import { Accordion } from '../components/accordion';
import { demoteStampedHeadings } from '../components/stampedHeadings';

categoryAccordion();
demoteStampedHeadings();
new Accordion('.accordion-spec');